<template>
  <v-container>
    <!-- Stripe Express is not enabled. No integration found. Ask to sign up to start processing -->
    <div v-if="!modules.backofficestripeexpress">
      <v-card color="black" dark>
        <v-card-text>
          <h1>Start Processing Payments Today!</h1>
          <p>
            This application uses Stripe to get you paid quickly and keep your personal and
            payment information secure. Thousands of companies around the world trust
            Stripe to process payments for their users. Set up a Stripe account to get
            paid through this application.
          </p>
          <p class="mb-0">
            Contact your account manager to enable Stripe Express.
          </p>
        </v-card-text>
      </v-card>
    </div>
    <div v-else>
      <!-- Stripe integration found and account is there. Options to see paymnets made, and terminals connected -->
      <!-- Option to sign up for Cash Discounting for free device by location-->
      <!-- Since it's by location then that means that the back end should payout based on location values -->
      <v-card>
        <v-toolbar :color="$style.card.header" class="elevation-0">
          <v-toolbar-title>
            <v-layout column fill-height>
              <span class="title">{{ $t('pageHeader.stripeExpress') }}</span>
            </v-layout>
          </v-toolbar-title>
        </v-toolbar>

        <Locations />
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex"
// import stripeConnectService from '../StripeConnect/service'
import Locations from "./components/Locations"

export default {
  name: "stripe-express",
  components: {
    Locations,
  },
  data() {
    return {
      isLoading: false,
      stripeConnect: null,
    }
  },
  computed: {
    ...mapGetters("integration", ["modules"]),
  },
  async created() {
    if (this.modules.backofficestripeexpress) {
      // Get stripe connect information
      // this.stripeConnect = (await stripeConnectService.getInfo()).data
    }
  },
}
</script>

<style></style>
